/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Sdh_RemovalInputs */



/**
* | output |
* | --- |
* | "Apply SDH removal" |
*
* @param {Apply_Sdh_RemovalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_sdh_removal = /** @type {((inputs?: Apply_Sdh_RemovalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Sdh_RemovalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer la suppression SDH")
	if (locale === "de") return /** @type {LocalizedString} */ ("SDH-Entfernung anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicare la rimozione SDH")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примените удаление SDH")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar la eliminación de SDH")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用SDH去除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SDH除去を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसडीएच हटाने के लिए आवेदन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar remoção de SDH")
	return /** @type {LocalizedString} */ ("Apply SDH removal")
});